import { render, staticRenderFns } from "./ViewShippingDetails.vue?vue&type=template&id=763502dd&scoped=true"
import script from "./ViewShippingDetails.vue?vue&type=script&lang=js"
export * from "./ViewShippingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763502dd",
  null
  
)

export default component.exports